import { __read } from "tslib";
import { createContext, useState, useContext } from 'react';
var createSource = function () { return ({
    value: 1,
}); };
var counter = createSource();
var source = createContext(createSource());
var getId = function (source) { return source.value++; };
var generateUniqId = function (context, prefix) {
    if (prefix === void 0) { prefix = ''; }
    var id = getId(context || counter);
    return "" + prefix + id;
};
export var useUniqId = function (prefix) {
    var _a = __read(useState(generateUniqId(useContext(source), prefix)), 1), id = _a[0];
    return id;
};
